var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupStarOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.125,
    height: 36.355,
    viewBox: "0 0 38.125 36.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_214958",
    "data-name": "Path 214958",
    d: "M187.588,30.753l.1.014h.046a.363.363,0,0,1,.054.055.612.612,0,0,1,.1.169.436.436,0,0,1,.029.143c0,.056,0,.1-.007.134l-.033.027-.042.033-.143.114c-.074.06-.168.139-.264.233l-6.411,6.255a4.286,4.286,0,0,0-1.229,3.808l1.642,9.36a.007.007,0,0,1,0,0,.56.56,0,0,1-.3.615h-.193c-.143,0-.228,0-.281,0l-.119-.07-.011-.007c-.061-.037-.152-.092-.253-.145l-8-4.234a4.285,4.285,0,0,0-4.01,0l-8.378,4.435-.033.018-.033.02a.39.39,0,0,1-.331.047.661.661,0,0,1-.336-.259,1.108,1.108,0,0,1-.025-.253,1.08,1.08,0,0,1,.02-.213l1.6-9.127a4.285,4.285,0,0,0-1.228-3.808l-6.722-6.558a.474.474,0,0,1-.146-.276.391.391,0,0,1,.063-.258c.08-.128.128-.2.171-.26h.149l.1-.014,9.343-1.311a4.285,4.285,0,0,0,3.266-2.387L169.8,18.6a.668.668,0,0,1,.349-.276.39.39,0,0,1,.331.047l.047.028.049.024c.04.02.065.035.079.044s.023.039.044.08l4.281,8.562a4.284,4.284,0,0,0,3.237,2.327Zm.126,0,.006,0ZM170.67,18.479l0,0Zm-.022-.022,0,0Z",
    transform: "translate(-151.215 -16.875)",
    fill: "none",
    stroke: "#735ae5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.857
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupStarOutlined);
export default __webpack_public_path__ + "static/media/popup-star_outlined.358e2872e749c9f8a8db73f8950b6dc1.svg";
export { ForwardRef as ReactComponent };